import { B2bPlanCategoryEsPerecoiValues, B2bSavingPlanType } from '@Common/types/b2b/plans';

/**
 * Plan *types* embed their category (e.g. `PERCOI_...`), so membership is a substring
 * check rather than an equality check against the category list.
 */
export const isPerecoiPlanType = (planType: B2bSavingPlanType): boolean =>
  B2bPlanCategoryEsPerecoiValues.some((perecoiValue) => planType.includes(perecoiValue));
